import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import EditArticle from './components/EditArticle';
import { AuthProvider } from './context/authContext';
import ProtectedRoute from './components/protectedRoute';
import EditFlip from './components/flipbook';
import EditChapter from './components/EditChapter';
function App() {
    return (
        <AuthProvider>
            <Router>
                <Routes>
                    <Route path="/" element={<Login />} />
                    <Route
                        path="/dashboard"
                        element={
                            <ProtectedRoute>
                                <Dashboard />
                            </ProtectedRoute>
                        }
                    />
                     <Route path="/flipbook" element={<EditFlip />} />
                     <Route path="/edit-chapter/:chapterId" element={<EditChapter />} />
                    <Route
                        path="/edit/:id"
                        element={
                            <ProtectedRoute>
                                <EditArticle />
                            </ProtectedRoute>
                        }
                    />
                </Routes>
            </Router>
        </AuthProvider>
    );
}

export default App;
